// eslint-disable-next-line no-unused-vars
import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Row, Container} from 'react-bootstrap';
import MiddleContainer from './ui/middleContainer';
import RightSideContainer from './ui/rightSideContainer';
import LoginSectionComponent from './ui/loginSectionComponent';
import TopPlayersSectionComponent from './ui/topPlayersSectionComponent';
import TopTableSmall from './ui/table/topTableSmall';
import StatisticsTable from './ui/table/statisticsTable';
import SectionContainer from './ui/sectionContainer';
// eslint-disable-next-line no-unused-vars
import DiscordWidget from './widget/discordWidget';
import CustomDiscordWidget from './widget/customDiscordWidget';
import {getServerStatus, getActiveServers} from '../api/axios';
import {useAuth} from '../hooks/useAuth';

const MainContainer = styled.main`
  position: relative;
  top: -50px;
  z-index: 2;
`;

const StyledContainer = styled(Container)``;
const StyledRow = styled(Row)``;

const initialServerStatsData = [
  {label: 'Server Status', value: 'Offline'},
  {label: 'Players Online', value: '0'},
  {label: 'EXP Rate', value: 'x0'},
  {label: 'Drop Rate', value: 'x0'},
  {label: 'Taming Rate', value: 'x2'},
  {label: '-', value: '-'},
];

const serverName = 'Arcane x Immortal';

function normalizeStatus(data) {
  if (Array.isArray(data)) data = data[0];
  const {Player_Online = 0, Current_EXP_Rate = 0, Current_Drop_Rate = 0, Server_Status = 'Offline'} = data || {};
  return [
    {label: 'Server Status', value: Server_Status},
    {label: 'Players Online', value: Player_Online},
    {label: 'EXP Rate', value: `x${Current_EXP_Rate}`},
    {label: 'Drop Rate', value: `x${Current_Drop_Rate}`},
    {label: 'Taming Rate', value: 'x2'},
    {label: '-', value: '-'},
  ];
}

const LABEL_PLAYERS = 'Players Online';

function hidePlayersOnlineIfNotAllowed(rows, canSee) {
  if (canSee) return rows;
  return rows.filter(r => r.label !== LABEL_PLAYERS);
}

const Main = () => {
  const {user} = useAuth();
  const canSeePlayersOnline = !!user && Number(user.permission) === 3;

  const [serverStatsHybrid, setServerStatsHybrid] = useState(initialServerStatsData);
  const [serverStatsPvp, setServerStatsPvp] = useState(initialServerStatsData);
  const [serverStatsSaison, setServerStatsSaison] = useState(initialServerStatsData);

  const [active, setActive] = useState({hybrid: false, pvp: false, saison: false});
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      setLoading(true);

      // 1) aktive Server laden (API gibt nur is_active=1 zurück)
      const listRes = await getActiveServers();
      const servers = Array.isArray(listRes.data?.servers) ? listRes.data.servers : [];

      const isHybridActive = servers.some(s => s.friendly_key === 'hybrid');
      const isPvpActive = servers.some(s => s.friendly_key === 'pvp');
      const isSaisonActive = servers.some(s => s.friendly_key === 'saison');
      setActive({hybrid: isHybridActive, pvp: isPvpActive, saison: isSaisonActive});

      // 2) Status nur für aktive Server abrufen (parallel)
      const jobs = [];
      if (isHybridActive) jobs.push(getServerStatus('hybrid').then(r => setServerStatsHybrid(normalizeStatus(r.data))));
      else setServerStatsHybrid(initialServerStatsData);

      if (isPvpActive) jobs.push(getServerStatus('pvp').then(r => setServerStatsPvp(normalizeStatus(r.data))));
      else setServerStatsPvp(initialServerStatsData);

      if (isSaisonActive) jobs.push(getServerStatus('saison').then(r => setServerStatsSaison(normalizeStatus(r.data))));
      else setServerStatsSaison(initialServerStatsData);

      await Promise.all(jobs);
    } catch (e) {
      // Fallback: alles auf offline/initial
      setServerStatsHybrid(initialServerStatsData);
      setServerStatsPvp(initialServerStatsData);
      setServerStatsSaison(initialServerStatsData);
      setActive({hybrid: false, pvp: false, saison: false});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh(); // initialer Aufruf
    const interval = setInterval(refresh, 6000); // 60s
    return () => clearInterval(interval);
  }, []);

  return (
    <MainContainer>
      <StyledContainer>
        <StyledRow>
          <MiddleContainer />
          <RightSideContainer>
            <LoginSectionComponent>
              {/* HYBRID nur anzeigen, wenn aktiv */}
              <SectionContainer title={'STATISTICS'} withLoginContent={true}>
                {active.hybrid && (
                  <StatisticsTable
                    stats={hidePlayersOnlineIfNotAllowed(serverStatsHybrid, canSeePlayersOnline)}
                    serverName={`${serverName} (HYBRID)`}
                  />
                )}

                {active.pvp && (
                  <StatisticsTable
                    stats={hidePlayersOnlineIfNotAllowed(serverStatsPvp, canSeePlayersOnline)}
                    serverName={`${serverName} (PVP)`}
                  />
                )}

                {active.saison && (
                  <StatisticsTable
                    stats={hidePlayersOnlineIfNotAllowed(serverStatsSaison, canSeePlayersOnline)}
                    serverName={`${serverName} (SAISON)`}
                  />
                )}
              </SectionContainer>

              {/* Optional: Placeholder, wenn keiner aktiv ist */}
              {!loading && !active.hybrid && !active.pvp && !active.saison && (
                <SectionContainer title={'STATISTICS'} withLoginContent={true}>
                  <div style={{padding: 12, opacity: 0.8}}>NO SERVER IS ACTIV !!!!!!!</div>
                </SectionContainer>
              )}
            </LoginSectionComponent>

            {/* <DiscordWidget /> */}
            <CustomDiscordWidget />

            <TopPlayersSectionComponent>
              {active.hybrid && (
                <SectionContainer title={'TOP PLAYER HYBRID'} withLoginContent={false}>
                  <TopTableSmall server={'hybrid'} />
                </SectionContainer>
              )}

              {active.pvp && (
                <SectionContainer title={'TOP PLAYER PVP'} withLoginContent={false}>
                  <TopTableSmall server={'pvp'} />
                </SectionContainer>
              )}

              {active.saison && (
                <SectionContainer title={'TOP PLAYER SAISON'} withLoginContent={false}>
                  <TopTableSmall server={'saison'} />
                </SectionContainer>
              )}
            </TopPlayersSectionComponent>
          </RightSideContainer>
        </StyledRow>
      </StyledContainer>
    </MainContainer>
  );
};

export default Main;
